module.exports = __webpack_public_path__ + "static/11-79d6f5628e613898f8b3c0128b697a91.jpg";